var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 176,
    viewBox: "0 0 103 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6152 116.663C33.4904 121.172 37.7136 119.91 40.8993 124.322C41.2651 124.828 43.1328 127.417 42.7593 130.74C42.4611 133.387 40.8597 135.43 39.8524 136.329C33.7289 141.787 16.8787 135.109 7.22857 127.806C5.12473 126.213 -0.520463 121.941 0.616495 118.907C1.08246 117.664 2.52929 117.046 3.56762 116.619C8.15817 114.728 12.9196 115.983 15.6152 116.663Z",
    fill: "url(#paint0_linear_31887_118819)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8051 6.01953H67.0005V29.01H70.8051V6.01953Z",
    fill: "url(#paint1_linear_31887_118819)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0407 41.7097H55.7648C53.8272 41.7097 52.2568 40.2637 52.2568 38.4794V29.8319C52.2568 28.0476 53.8272 26.6016 55.7648 26.6016H82.0407C83.9783 26.6016 85.5486 28.0476 85.5486 29.8319V38.4794C85.5478 40.2637 83.9775 41.7097 82.0407 41.7097Z",
    fill: "url(#paint2_linear_31887_118819)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.466 91.9653C128.466 105.932 116.17 117.255 101.003 117.255H36.8027C21.6976 117.255 9.33936 105.875 9.33936 91.9653V78.8281C9.33936 54.0806 31.3276 33.832 58.203 33.832H79.6033C106.478 33.832 128.467 54.0799 128.467 78.8281L128.466 91.9653Z",
    fill: "url(#paint3_linear_31887_118819)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.729 89.5686C108.17 90.278 106.423 90.6499 104.647 90.6499H33.1587C31.3833 90.6499 29.6359 90.278 28.0773 89.5686C24.2486 87.8258 22.0881 84.3066 22.6286 80.6965L22.6682 80.434C24.5002 68.2058 36.5268 58.8045 51.2716 58.098C57.5101 57.799 64.0569 57.6446 70.8857 57.681C76.235 57.7097 81.4056 57.8541 86.3845 58.0901C101.185 58.7924 113.3 68.1565 115.139 80.4312C115.152 80.5192 115.166 80.6078 115.179 80.6958C115.719 84.3065 113.557 87.8258 109.729 89.5686Z",
    fill: "url(#paint4_linear_31887_118819)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.062 87.9597C57.507 87.9597 63.5424 82.402 63.5424 75.5463C63.5424 68.6905 57.507 63.1328 50.062 63.1328C42.6169 63.1328 36.5815 68.6905 36.5815 75.5463C36.5815 82.402 42.6169 87.9597 50.062 87.9597Z",
    fill: "url(#paint5_radial_31887_118819)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.062 84.4567C55.4058 84.4567 59.7378 80.4675 59.7378 75.5467C59.7378 70.6258 55.4058 66.6367 50.062 66.6367C44.7182 66.6367 40.3862 70.6258 40.3862 75.5467C40.3862 80.4675 44.7182 84.4567 50.062 84.4567Z",
    fill: "#EEFDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0625 83.0368C54.5506 83.0368 58.189 79.6865 58.189 75.5536C58.189 71.4207 54.5506 68.0703 50.0625 68.0703C45.5744 68.0703 41.936 71.4207 41.936 75.5536C41.936 79.6865 45.5744 83.0368 50.0625 83.0368Z",
    fill: "url(#paint6_linear_31887_118819)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2674 73.6039C55.2674 75.1351 53.9199 76.3758 52.2572 76.3758C50.5945 76.3758 49.2471 75.1343 49.2471 73.6039C49.2471 72.0735 50.5945 70.832 52.2572 70.832C53.9199 70.832 55.2674 72.0735 55.2674 73.6039Z",
    fill: "#EEFDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8606 82.3884C49.5241 82.3884 50.062 81.8931 50.062 81.2821C50.062 80.6711 49.5241 80.1758 48.8606 80.1758C48.1971 80.1758 47.6592 80.6711 47.6592 81.2821C47.6592 81.8931 48.1971 82.3884 48.8606 82.3884Z",
    fill: "#EEFDFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8818 79.6231C45.8818 79.9285 45.6131 80.1759 45.2815 80.1759C44.9499 80.1759 44.6812 79.9285 44.6812 79.6231C44.6812 79.3178 44.9499 79.0703 45.2815 79.0703C45.6131 79.0703 45.8818 79.3185 45.8818 79.6231Z",
    fill: "#EEFDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4785 87.9597C93.9235 87.9597 99.9589 82.402 99.9589 75.5463C99.9589 68.6905 93.9235 63.1328 86.4785 63.1328C79.0334 63.1328 72.998 68.6905 72.998 75.5463C72.998 82.402 79.0334 87.9597 86.4785 87.9597Z",
    fill: "url(#paint7_radial_31887_118819)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4781 84.4567C91.8218 84.4567 96.1538 80.4675 96.1538 75.5467C96.1538 70.6258 91.8218 66.6367 86.4781 66.6367C81.1343 66.6367 76.8022 70.6258 76.8022 75.5467C76.8022 80.4675 81.1343 84.4567 86.4781 84.4567Z",
    fill: "#EEFDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.478 83.0368C90.9662 83.0368 94.6045 79.6865 94.6045 75.5536C94.6045 71.4207 90.9662 68.0703 86.478 68.0703C81.9899 68.0703 78.3516 71.4207 78.3516 75.5536C78.3516 79.6865 81.9899 83.0368 86.478 83.0368Z",
    fill: "url(#paint8_linear_31887_118819)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6851 73.6039C91.6851 75.1351 90.3369 76.3758 88.675 76.3758C87.013 76.3758 85.6641 75.1343 85.6641 73.6039C85.6641 72.0735 87.0123 70.832 88.675 70.832C90.3377 70.832 91.6851 72.0735 91.6851 73.6039Z",
    fill: "#EEFDFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2771 82.3884C85.9406 82.3884 86.4785 81.8931 86.4785 81.2821C86.4785 80.6711 85.9406 80.1758 85.2771 80.1758C84.6136 80.1758 84.0757 80.6711 84.0757 81.2821C84.0757 81.8931 84.6136 82.3884 85.2771 82.3884Z",
    fill: "#EEFDFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2988 79.6231C82.2988 79.9285 82.0301 80.1759 81.6985 80.1759C81.3669 80.1759 81.0981 79.9285 81.0981 79.6231C81.0981 79.3178 81.3669 79.0703 81.6985 79.0703C82.0301 79.0703 82.2988 79.3185 82.2988 79.6231Z",
    fill: "#EEFDFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7771 4.48896C73.7771 6.96764 71.5948 8.97792 68.9023 8.97792C66.2106 8.97792 64.0283 6.96836 64.0283 4.48896C64.0283 2.01027 66.2106 0 68.9023 0C71.5948 0 73.7771 2.00955 73.7771 4.48896Z",
    fill: "url(#paint9_linear_31887_118819)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2912 2.73988C72.2912 3.49579 71.6257 4.10795 70.8048 4.10795C69.9839 4.10795 69.3184 3.49507 69.3184 2.73988C69.3184 1.98397 69.9839 1.37109 70.8048 1.37109C71.6257 1.37181 72.2912 1.98397 72.2912 2.73988Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110.874 48.2224C110.939 50.3178 109.081 52.8243 106.953 53.0382C104.959 53.2391 103.366 51.3626 101.723 49.4274C100.104 47.5201 96.5635 42.62 97.9738 41.234C99.8322 39.4068 110.721 43.2786 110.874 48.2224Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6537 40.2405C93.5892 40.2405 94.3475 39.5422 94.3475 38.6808C94.3475 37.8194 93.5892 37.1211 92.6537 37.1211C91.7183 37.1211 90.96 37.8194 90.96 38.6808C90.96 39.5422 91.7183 40.2405 92.6537 40.2405Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110.633 77.2883C110.089 77.6416 106.3 70.5331 96.1281 64.37C92.5525 62.2031 89.0228 60.6591 89.2325 60.21C89.4453 59.7544 93.4208 60.6019 96.6033 61.9614C106.744 66.2937 111.279 76.8685 110.633 77.2883Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5851 31.0746C84.464 31.0903 84.3863 30.4345 83.793 29.4212C83.793 29.4212 83.5157 28.947 83.1989 28.5451C82.1776 27.2507 78.7155 27.2793 78.4437 27.2815C73.0517 27.3244 69.5849 27.0097 69.5864 27.0398C69.5872 27.0648 72.1159 27.0176 73.9688 26.9833C79.1962 26.8853 82.3104 26.6264 83.6454 27.9158C84.1991 28.4507 84.4779 29.1473 84.4779 29.1473C84.8554 30.0927 84.7296 31.0553 84.5851 31.0746Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4641 95.9732C83.3321 97.1624 82.2572 98.0785 80.965 98.193L63.1076 99.7784C61.8161 99.8929 60.5704 99.1841 60.1937 98.0399C60.026 97.5315 59.8971 97.0072 59.8093 96.468C59.7852 96.3193 59.8279 96.1677 59.9289 96.0482C60.0299 95.9295 60.179 95.8544 60.3421 95.8394L82.8708 93.8385C83.0315 93.8241 83.1907 93.8713 83.3126 93.9686C83.4346 94.0659 83.5068 94.2053 83.5138 94.3534C83.541 94.9019 83.5231 95.4425 83.4641 95.9732Z",
    fill: "#EEFDFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4645 95.9766C82.8937 101.074 78.4926 105.265 72.7434 105.77C67.0725 106.276 61.9508 103.038 60.2671 98.2429C60.7167 99.2677 61.8863 99.892 63.1064 99.7797L80.9684 98.1964C82.2592 98.0784 83.3293 97.1651 83.4645 95.9766Z",
    fill: "url(#paint10_linear_31887_118819)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 132.908C111.6 133.059 111.6 133.203 111.593 133.341C111.536 134.721 111.186 135.759 111.015 136.225C106.1 150.052 103.154 157.344 99.024 163.242C98.3111 164.261 97.5616 165.239 96.7555 166.198C95.7001 167.479 94.5445 168.727 93.26 170.015C90.4067 172.872 86.0911 174.166 84.7002 174.613C79.6141 176.269 75.1199 175.966 72.1315 175.993H71.6104C68.6142 175.966 64.1277 176.269 59.0417 174.613C57.6508 174.166 53.3282 172.872 50.4819 170.015C42.635 162.152 39.6179 155.616 32.727 136.225C32.5632 135.779 32.2346 134.812 32.1562 133.519C32.1352 133.144 32.1275 132.77 32.1492 132.395C32.2991 130.077 33.3188 127.803 35.1314 125.728C38.2348 122.168 43.028 120.217 47.9859 120.197L71.8752 120.105L95.3297 120.02C100.395 120 105.302 121.958 108.519 125.563C110.074 127.311 111.065 129.196 111.43 131.14C111.479 131.416 111.522 131.699 111.551 131.975C111.578 132.284 111.6 132.593 111.6 132.908Z",
    fill: "url(#paint11_linear_31887_118819)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.87 120.105L47.9807 120.197C43.0228 120.217 38.2296 122.168 35.1262 125.728C33.3144 127.804 32.2947 130.077 32.144 132.395C32.2652 130.017 33.3284 127.685 35.2186 125.563C38.4284 121.957 43.3436 120 48.4078 120.02L71.87 120.105Z",
    fill: "url(#paint12_linear_31887_118819)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6144 152.519C95.2657 135.455 92.758 132.08 96.4562 128.021C96.881 127.555 99.0501 125.174 102.617 124.566C105.459 124.082 108.039 124.92 109.26 125.557C116.675 129.425 114.475 146.196 109.59 156.783C108.526 159.091 105.668 165.283 102.186 165.135C100.759 165.075 99.7071 163.97 98.9693 163.175C95.7037 159.652 95.6672 155.091 95.6144 152.519Z",
    fill: "url(#paint13_linear_31887_118819)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0236 163.247C98.3106 164.266 97.5612 165.244 96.7551 166.203C96.498 165.96 96.2697 165.717 96.0631 165.493C92.7959 161.973 92.7602 157.414 92.7105 154.839C92.361 137.774 89.8502 134.404 93.5523 130.344C93.8234 130.042 94.8151 128.958 96.4274 128.059C92.775 132.105 95.2648 135.508 95.6142 152.521C95.6639 155.095 95.7066 159.654 98.9669 163.182C98.9878 163.201 99.0096 163.221 99.0236 163.247Z",
    fill: "url(#paint14_linear_31887_118819)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31887_118819",
    x1: 25.7884,
    y1: 127.037,
    x2: 90.7126,
    y2: 181.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#59BBD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31887_118819",
    x1: 61.1492,
    y1: 18.5559,
    x2: 72.5202,
    y2: 16.7551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#AAE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31887_118819",
    x1: 58.2377,
    y1: 45.2435,
    x2: 76.6431,
    y2: 22.6771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#91DDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31887_118819",
    x1: 28.901,
    y1: 118.189,
    x2: 102.559,
    y2: 38.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B1EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_31887_118819",
    x1: 68.6916,
    y1: 90.5433,
    x2: 69.2965,
    y2: 60.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_31887_118819",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0617 75.5462) scale(13.3409 12.285)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_31887_118819",
    x1: 41.9354,
    y1: 75.5535,
    x2: 58.189,
    y2: 75.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_31887_118819",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(86.4783 75.5462) scale(13.3409 12.285)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_31887_118819",
    x1: 78.3511,
    y1: 75.5535,
    x2: 94.6046,
    y2: 75.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_31887_118819",
    x1: 58.6417,
    y1: 5.86661,
    x2: 73.69,
    y2: 3.4834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#99DFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_31887_118819",
    x1: 68.415,
    y1: 102.023,
    x2: 89.7416,
    y2: 78.8629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0714,
    stopColor: "#4FA6AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_31887_118819",
    x1: 46.4673,
    y1: 166.96,
    x2: 102.266,
    y2: 96.2009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64CEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#64CEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7DD5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8004,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_31887_118819",
    x1: 43.2052,
    y1: 133.949,
    x2: 76.7604,
    y2: 91.3972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_31887_118819",
    x1: 122.762,
    y1: 157.074,
    x2: 79.3739,
    y2: 122.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    stopColor: "#9CE4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8955,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_31887_118819",
    x1: 82.1363,
    y1: 154.068,
    x2: 113.602,
    y2: 136.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.c7e4aa3f.svg";
export { ForwardRef as ReactComponent };